var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DD1B78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.992 16.48C10.992 17.6213 10.672 18.512 10.032 19.152C9.392 19.7813 8.51733 20.096 7.408 20.096C6.02133 20.096 4.86933 19.536 3.952 18.416L4.96 16.816C5.33333 17.2107 5.728 17.52 6.144 17.744C6.57067 17.9573 6.97067 18.064 7.344 18.064C7.81333 18.064 8.176 17.9253 8.432 17.648C8.69867 17.36 8.832 16.9547 8.832 16.432V10.704H4.976V8.8H10.992V16.48ZM17.6726 8.8C18.7926 8.8 19.7953 9.04 20.6806 9.52C21.566 9.98933 22.2593 10.6507 22.7606 11.504C23.262 12.3573 23.5126 13.3227 23.5126 14.4C23.5126 15.4773 23.2566 16.4427 22.7446 17.296C22.2433 18.1387 21.5446 18.8 20.6486 19.28C19.7526 19.76 18.734 20 17.5926 20H13.0166V8.8H17.6726ZM17.7206 18.112C18.4033 18.112 19.0166 17.9573 19.5606 17.648C20.1153 17.328 20.5473 16.8907 20.8566 16.336C21.166 15.7707 21.3206 15.1307 21.3206 14.416C21.3206 13.7013 21.1606 13.0613 20.8406 12.496C20.5206 11.92 20.078 11.4773 19.5126 11.168C18.958 10.848 18.334 10.688 17.6406 10.688H15.1606V18.112H17.7206Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.f4e333ab03c7263e17ffe97da7d8010d.svg";
export { ForwardRef as ReactComponent };